import { compose } from "redux";

import DetailedARSProvider from "./Detailed";
import Default from "./Default";
import Error from "../Error";
import withContainer from "../common/hoc/WithContainer";
import injectLayoutWithQuickLinks from "../InjectLayoutWithQuickLinks";
import extractId from "../ExtractId";

import { getObjectById } from "../../services/MODSService";

const type = "ARSProvider";
export default compose(
    extractId(),
    withContainer({
        dataParams: {
            fetchHandler: getObjectById
        },
        defaultLoadingMessage: "Loading ARS Provider",
        Error,
        DefaultComponent: Default
    }),
    injectLayoutWithQuickLinks(type)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
)(DetailedARSProvider) as React.FunctionComponent<any>;
